import { Component, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BarcodeFormat } from '@zxing/library';
import { BehaviorSubject } from 'rxjs';
import { FormatsDialogComponent } from './formats-dialog/formats-dialog.component';
import { AppInfoDialogComponent } from './app-info-dialog/app-info-dialog.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
//import { ZXingScannerModule } from '../../../../node_modules/@zxing/ngx-scanner/lib/zxing-scanner.module';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatFormField } from '@angular/material/form-field';
import { AsyncPipe } from '@angular/common';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'app-scanner',
    templateUrl: 'app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [MatMenu, MatSelectionList, MatListOption, MatMenuItem, MatFormField, MatSelect, FormsModule, MatOption, MatIconButton, MatMenuTrigger, MatIcon, ZXingScannerModule, AsyncPipe]
})
export class ScannerComponent {

  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;
  selectedDevice: string = "";

  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.QR_CODE
  ];

  hasDevices: boolean;
  hasPermission: boolean;

  qrResultString: string;

  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = true;

  @Output() scanSuccess: EventEmitter<any> = new EventEmitter();

  constructor(private readonly _dialog: MatDialog) { }

  clearResult(): void {
    this.qrResultString = null;
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
    this.currentDevice = this.availableDevices[0];
    for (var i = 0; i < this.availableDevices.length; i++) {
      if (/back|rear|environment/gi.test(this.availableDevices[i].label)) { 
        this.currentDevice = this.availableDevices[i];
        break;
      }
    }
    this.selectedDevice = this.currentDevice.deviceId;
  }

  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
    this.scanSuccess.emit(resultString);
  }

  onDeviceSelectChange(selected: string) {
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.currentDevice = device || null;
  }

  openFormatsDialog() {
    const data = {
      formatsEnabled: this.formatsEnabled,
    };

    this._dialog
      .open(FormatsDialogComponent, { data })
      .afterClosed()
      .subscribe(x => { if (x) { this.formatsEnabled = x; } });
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }

  openInfoDialog() {
    const data = {
      hasDevices: this.hasDevices,
      hasPermission: this.hasPermission,
    };

    this._dialog.open(AppInfoDialogComponent, { data });
  }

  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }
}